const Icon = {}

export default Icon
